// src/hooks/useUnreadCount.ts
import { useEffect, useState } from 'react';
import supabase from '../config/supabaseConfig';
import { useAuth } from './useAuth';

export const useUnreadCount = () => {
    const [unreadCount, setUnreadCount] = useState(0);
    const { user } = useAuth();

    useEffect(() => {
        if (!user?.id) return;

        const fetchUnreadCount = async () => {
            try {
                // First get all chats for the user
                const { data: chats, error: chatsError } = await supabase
                    .from('chats')
                    .select('chat_id')
                    .contains('users', [user.id]);

                if (chatsError) throw chatsError;

                if (chats && chats.length > 0) {
                    const chatIds = chats.map(chat => chat.chat_id);

                    // Then count unread messages in these chats
                    const { data: unreadMessages, error: messagesError } = await supabase
                        .from('messages')
                        .select('id', { count: 'exact' })
                        .in('chat_id', chatIds)
                        .eq('is_read', false)
                        .neq('sender', user.id);

                    if (messagesError) throw messagesError;

                    setUnreadCount(unreadMessages?.length || 0);
                } else {
                    setUnreadCount(0);
                }
            } catch {
                // Silent fail - we don't want to disrupt the UI for message counts
                setUnreadCount(0);
            }
        };

        // Initial fetch
        fetchUnreadCount();

        // Set up a polling mechanism instead of realtime subscription
        const pollingInterval = setInterval(fetchUnreadCount, 5000); // Poll every 5 seconds

        return () => {
            clearInterval(pollingInterval);
        };
    }, [user?.id]);

    return unreadCount;
};